@if (open) {
  <div class="fixed inset-0 z-[60] flex items-end sm:items-center justify-center sm:p-4">
    <div class="absolute inset-0 bg-gray-900/60 backdrop-blur-sm" (click)="close()"></div>

    <div class="relative bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl w-full max-w-lg max-h-[92dvh] sm:max-h-[90vh] overflow-hidden flex flex-col">
      <div class="sm:hidden mx-auto mt-3 h-1 w-10 rounded-full bg-gray-300 flex-shrink-0"></div>
      <div class="px-4 sm:px-6 py-4 border-b border-gray-200 flex items-center justify-between">
        <h3 class="text-lg font-semibold text-gray-900">{{ title() }}</h3>
        <button (click)="close()" class="text-gray-400 hover:text-gray-600">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto overscroll-contain px-4 sm:px-6 py-4 space-y-5">
        <!-- Action selector -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Action</label>
          <div class="inline-flex rounded-lg border border-gray-300 overflow-hidden text-sm">
            <button type="button" (click)="setAction('add')"
                    [class]="action() === 'add'
                      ? 'px-3 py-1.5 bg-blue-600 text-white font-medium'
                      : 'px-3 py-1.5 bg-white text-gray-700 hover:bg-gray-50'">
              Add
            </button>
            <button type="button" (click)="setAction('remove')"
                    [class]="action() === 'remove'
                      ? 'px-3 py-1.5 bg-blue-600 text-white font-medium border-l border-gray-300'
                      : 'px-3 py-1.5 bg-white text-gray-700 hover:bg-gray-50 border-l border-gray-300'">
              Remove
            </button>
            <button type="button" (click)="setAction('replace')"
                    [class]="action() === 'replace'
                      ? 'px-3 py-1.5 bg-blue-600 text-white font-medium border-l border-gray-300'
                      : 'px-3 py-1.5 bg-white text-gray-700 hover:bg-gray-50 border-l border-gray-300'">
              Replace
            </button>
          </div>
          <p class="text-xs text-gray-500 mt-2">
            @switch (action()) {
              @case ('add') { Selected committees are added to each member's existing assignments. }
              @case ('remove') { Selected committees are removed from each member's assignments. Members can end up unassigned. }
              @case ('replace') { Each member's committees are replaced with exactly the selected set. }
            }
          </p>
        </div>

        <!-- BU multi-select -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Committees</label>
          <div class="space-y-2 max-h-64 overflow-y-auto border border-gray-200 rounded-lg p-3">
            @for (unit of activeUnits(); track unit.id) {
              <div class="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 cursor-pointer"
                   (click)="toggleBu(unit.id)">
                <div class="w-4 h-4 rounded border-2 flex items-center justify-center flex-shrink-0 transition-colors"
                     [class.bg-blue-600]="isBuSelected(unit.id)"
                     [class.border-blue-600]="isBuSelected(unit.id)"
                     [class.border-gray-300]="!isBuSelected(unit.id)">
                  @if (isBuSelected(unit.id)) {
                    <svg class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
                    </svg>
                  }
                </div>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-gray-900 truncate">{{ unit.name }}</p>
                  @if (unit.description) {
                    <p class="text-xs text-gray-500 truncate">{{ unit.description }}</p>
                  }
                </div>
              </div>
            }
            @if (activeUnits().length === 0) {
              <div class="text-center text-gray-400 text-sm py-4">No active committees available</div>
            }
          </div>
        </div>

        @if (errorMessage()) {
          <div class="flex items-center gap-2 bg-red-50 border border-red-200 rounded-lg p-3">
            <svg class="w-5 h-5 text-red-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <p class="text-sm text-red-700">{{ errorMessage() }}</p>
          </div>
        }
      </div>

      <div class="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-2 sm:gap-3 px-4 sm:px-6 py-4 pb-[max(1rem,env(safe-area-inset-bottom))] sm:pb-4 border-t border-gray-200">
        <button (click)="close()" [disabled]="isSaving()"
                class="w-full sm:w-auto max-md:tap-target px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50">
          Cancel
        </button>
        <button (click)="submit()" [disabled]="isSaving()"
                class="w-full sm:w-auto max-md:tap-target inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-60 transition-colors">
          @if (isSaving()) { <app-spinner size="xs" colour="white"></app-spinner> }
          {{ isSaving() ? 'Saving...' : confirmLabel() }}
        </button>
      </div>
    </div>
  </div>
}
